const flight = {
    getlist: 'flight/getlist',
    add: 'flight/add',
    update: 'flight/update',
    remove: 'flight/remove',
    get: 'flight/get',
    getall: 'flight/getall',
    clearcache: 'flight/clear-cache',
}
export default flight
